var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner_warp"},[_c('img',{staticClass:"banner_warp_img",attrs:{"src":_vm.bannerImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }